export const AWS_ACCESS_KEY_ID = 'AKIA4HLVTHMMRAS4UEUA';
export const AWS_SECRET_ACCESS_KEY = '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';
export const AWS_STORAGE_BUCKET_NAME = 's3-bankend';
export const AWS_STORAGE_PDF_FOLDER = 'static/quote/'; 